var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.loading === "user"
        ? _c("p", { staticClass: "text-muted" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
            _vm._v(" Loading info for user " + _vm._s(_vm.userUuid) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("h4", [
              _vm._v("Error Loading User Events: " + _vm._s(_vm.error))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? [
            _c("h1", { staticClass: "light" }, [
              _vm._v(_vm._s(_vm.accountInfo.name) + ": "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.accountInfo.email))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c("p", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `#!/user_info?email=${_vm.accountInfo.email}`
                      }
                    },
                    [_vm._v("View user details")]
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("Title:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.accountInfo.title || "(unspecified)") +
                        " "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("Role:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " + _vm._s(_vm.accountInfo.role || "(unspecified)")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("p", [
                  _c("b", [_vm._v("Level:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " + _vm._s(_vm.accountInfo.level || "(unspecified)")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("District Name:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.accountInfo.district_name || "(unspecified)")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("School Name:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.accountInfo.school_name || "(unspecified)")
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("h2", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default pull-right",
                        attrs: { disabled: !!_vm.loading },
                        on: { click: _vm.refresh }
                      },
                      [_vm._v("Refresh")]
                    ),
                    _vm._v("\n          Event List "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("(" + _vm._s(this.events.length) + " Events)")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-info" }, [
                    _c("i", { staticClass: "fa fa-info-circle" }),
                    _vm._v(
                      " Events database is updated once a day. Last update: " +
                        _vm._s(_vm.tableRefreshedAtFormatted)
                    )
                  ]),
                  _vm._v(" "),
                  _vm.events.length > 0
                    ? _c("v-client-table", {
                        attrs: {
                          columns: _vm.eventsTableColumns,
                          data: _vm.events,
                          options: _vm.eventsTableOptions
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "name",
                              fn: function(props) {
                                return _c("b", {}, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.row.name) +
                                      "\n          "
                                  )
                                ])
                              }
                            },
                            {
                              key: "product",
                              fn: function(props) {
                                return _c("div", {}, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.row.source) +
                                      "\n          "
                                  )
                                ])
                              }
                            },
                            {
                              key: "time",
                              fn: function(props) {
                                return _c("div", {}, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        new Date(
                                          props.row.utc
                                        ).toLocaleDateString("en-US")
                                      ) +
                                      "\n            "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        new Date(
                                          props.row.utc
                                        ).toLocaleTimeString("en-US")
                                      ) +
                                      "\n          "
                                  )
                                ])
                              }
                            },
                            {
                              key: "data",
                              fn: function(props) {
                                return _c(
                                  "div",
                                  {},
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { role: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleDetails(
                                              props.index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("show/collapse")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "collapse",
                                      {
                                        model: {
                                          value: _vm.showDetails[props.index],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.showDetails,
                                              props.index,
                                              $$v
                                            )
                                          },
                                          expression: "showDetails[props.index]"
                                        }
                                      },
                                      [
                                        _c(
                                          "dl",
                                          {
                                            attrs: {
                                              id: `${props.index}-evt-data`
                                            }
                                          },
                                          [
                                            _vm._l(
                                              JSON.parse(props.row.data),
                                              function(val, key) {
                                                return [
                                                  val
                                                    ? _c("dt", { key: key }, [
                                                        _vm._v(_vm._s(key))
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  val
                                                    ? _c(
                                                        "dd",
                                                        { key: `${key}-val` },
                                                        [_vm._v(_vm._s(val))]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1156835864
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  !_vm.loading && _vm.canLoadMore
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.loadMoreEvents(_vm.lastEventUTC)
                            }
                          }
                        },
                        [_vm._v("Load More Events")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loading === "events"
                    ? _c("p", { staticClass: "loading text-muted" }, [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading events...\n        ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("h2", [_vm._v("Event Aggregation")]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.events.length > 0
                  ? _c(
                      "table",
                      { staticClass: "table table-striped table-condensed" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.aggregations, function(event) {
                            return _c("tr", { key: event.name }, [
                              _c("th", { attrs: { scope: "row" } }, [
                                _vm._v(_vm._s(event.name))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(event.count))])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-info" }, [
      _c("i", { staticClass: "fa fa-info-circle" }),
      _vm._v(" Only aggregates the events that are shown on the left")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Event Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Event Count")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }